import { PRODUCT, PRODUCT_GROUP } from 'utils/constants';

type ImageLogoProps = {
  file: string;
  alt: string;
  width?: number;
  height?: number;
};

const getPropsImage = (productId: number): ImageLogoProps => {
  if (PRODUCT.TC_EXPERIENCE === productId || PRODUCT.TC_EXPERIENCE_WEEKEND === productId) {
    return {
      file: `logo-lp-experience.png`,
      alt: `tc experience`,
    };
  }
  if (PRODUCT_GROUP.TC_HUB.includes(productId)) {
    return {
      file: `logo-lp-hub.svg`,
      alt: `tc hub`,
    };
  }
  if (PRODUCT.MOVER_PRO === productId) {
    return {
      file: `logo-lp-mover-pro.svg`,
      alt: `tc mover pro`,
    };
  }
  if (PRODUCT.TC_MASTER === productId) {
    return {
      file: `logo-lp-master.svg`,
      alt: `tc master`,
    };
  }
  if (PRODUCT.TC_MASTER_PRO === productId) {
    return {
      file: `logo-lp-master-pro.svg`,
      alt: `tc master pro`,
    };
  }
  if ([PRODUCT.TC_PREMIUM, PRODUCT.TC_PREMIUM_WITHOUT_CONSULTING].includes(productId)) {
    return {
      file: `logo-lp-premium.svg`,
      alt: `tc premium`,
    };
  }
  if (PRODUCT.TC_PRIVATE === productId) {
    return {
      file: `logo-lp-private.svg`,
      alt: `tc private`,
    };
  }

  return {
    file: ``,
    alt: ``,
  };
};

export default getPropsImage;
